import { render, staticRenderFns } from "./CanBoxOrders.vue?vue&type=template&id=4b8cb8d5&scoped=true"
import script from "./CanBoxOrders.vue?vue&type=script&lang=js"
export * from "./CanBoxOrders.vue?vue&type=script&lang=js"
import style0 from "./CanBoxOrders.vue?vue&type=style&index=0&id=4b8cb8d5&prod&lang=less&scoped=true"
import style1 from "./CanBoxOrders.vue?vue&type=style&index=1&id=4b8cb8d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cb8d5",
  null
  
)

export default component.exports